var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1667 1.89111V5.33323C12.1667 5.79994 12.1667 6.0333 12.2575 6.21156C12.3374 6.36836 12.4649 6.49584 12.6217 6.57574C12.8 6.66656 13.0333 6.66656 13.5 6.66656H16.9422M12.1667 14.1665H7.16671M13.8334 10.8332H7.16671M17.1667 8.32336V14.3332C17.1667 15.7333 17.1667 16.4334 16.8942 16.9681C16.6545 17.4386 16.2721 17.821 15.8017 18.0607C15.2669 18.3332 14.5668 18.3332 13.1667 18.3332H7.83337C6.43324 18.3332 5.73318 18.3332 5.1984 18.0607C4.72799 17.821 4.34554 17.4386 4.10586 16.9681C3.83337 16.4334 3.83337 15.7333 3.83337 14.3332V5.6665C3.83337 4.26637 3.83337 3.56631 4.10586 3.03153C4.34554 2.56112 4.72799 2.17867 5.1984 1.93899C5.73318 1.6665 6.43324 1.6665 7.83337 1.6665H10.5099C11.1213 1.6665 11.4271 1.6665 11.7148 1.73558C11.9699 1.79682 12.2137 1.89783 12.4374 2.0349C12.6897 2.18951 12.9059 2.4057 13.3383 2.83808L15.9951 5.49493C16.4275 5.92731 16.6437 6.1435 16.7983 6.39579C16.9354 6.61947 17.0364 6.86333 17.0976 7.11842C17.1667 7.40614 17.1667 7.71188 17.1667 8.32336Z",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadInfo);
export default __webpack_public_path__ + "static/media/load-info.b91410e5b3547d8f416fc0ea108cab14.svg";
export { ForwardRef as ReactComponent };